<template>
  <div class="c-masthead__link"><sc-link v-if="fields && fields.link" :field="fields.link" /></div>
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Masthead-Two-Column-Link',
  components: {
    ScLink: Link
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
